import type { CapiAuthorArchive } from 'types/capi/news';

import Paragraph from '~/components/Content/Paragraph';
import PageHeader from '~/components/PageHeader';
import usePageData from '~/hooks/usePageData';
import Grid from '~/modules/ArticlesSection/Grid';
import Pagination from '~/routes/plps/components/Products/Pagination';

import { StructuredData } from '../feed/NewsFeedView';

export const AUTHOR_ARCHIVE_MODULE_TYPE = 'author-archive-grid';

export default function AuthorArchiveView() {
  const { _schemas, articles, author, pagination } =
    usePageData<CapiAuthorArchive>();

  return (
    <div className="flex flex-col gap-8 pb-12">
      {_schemas ? <StructuredData schemas={_schemas} /> : null}
      <PageHeader
        avatar={{ alt: author.name, src: author.avatar }}
        breadcrumbs={[
          { label: 'Home', path: '/' },
          { label: 'News', path: '/news/' },
          { label: 'Authors' }
        ]}
        subtitle={author.title}
        title={author.name}
      >
        {author.biography ? (
          <div className="max-w-2xl text-light-grey">
            <Paragraph collapsible size="small" text={author.biography}>
              {author.biography}
            </Paragraph>
          </div>
        ) : null}
      </PageHeader>
      <Grid
        items={articles}
        moduleType={AUTHOR_ARCHIVE_MODULE_TYPE}
        pagePosition="Author Archive Grid"
      />
      {pagination.pages ? (
        <div className="content-width">
          <Pagination pagination={pagination} />
        </div>
      ) : null}
    </div>
  );
}
